import type { XvsVault } from 'libs/contracts';

export interface GetXvsVaultPoolCountInput {
  xvsTokenAddress: string;
  xvsVaultContract: XvsVault;
}

export type GetXvsVaultPoolCountOutput = {
  poolCount: number;
};

const getXvsVaultPoolCount = async ({
  xvsTokenAddress,
  xvsVaultContract,
}: GetXvsVaultPoolCountInput): Promise<GetXvsVaultPoolCountOutput> => {
  // console.log("xvsVaultPoolLength");
  // const xvsVaultPoolLength = await xvsVaultContract.poolLength(xvsTokenAddress);

  return {
    poolCount: 0// xvsVaultPoolLength.toNumber(),
  };
};

export default getXvsVaultPoolCount;
